module.exports = __webpack_public_path__ + "static/img/AG.fe720501.svg";